import { esEmpresaDemo } from './empresa-demo';

/**
 * Reglas de la demo (spec 343, S3.4): en la prueba, las listas de donde se eligen productos,
 * categorías o marcas para una regla o una estrategia ofrecen sólo los productos de ejemplo
 * activos. El servidor lo respeta con este parámetro en `GET /api/dynamic-pricing/products` y en
 * `GET /api/pricing-rules/scope/{products,categories,brands}`. Sin la marca de demo, la dirección
 * no cambia: una empresa común no manda ni un parámetro de más.
 */
export function conSoloEjemplos(url: string): string {
  if (!esEmpresaDemo()) return url;
  return `${url}${url.includes('?') ? '&' : '?'}soloEjemplos=1`;
}
